

export default {
    // main_url:"https://yxwpubmod.hntv.tv/mobile/cms/articles?channelId=1380880922508922880&tenantId=1&pageNo=1&pageSize=99"
    main_url:"https://yxwpubmod.hntv.tv/mobile/cms/articles?channelId=1380880922508922880&tenantId=1&pageNo=1&pageSize=99"
}